/* Early-access page behaviour.
   Loaded with `defer` so it runs after the whole template is parsed - the
   anchor resolver below needs every section to already exist in the DOM. */
(function () {
  if (window.__plwInit) return; // section renders many times on the page; run once
  window.__plwInit = true;

  function show(el, kind, text) {
    if (!el) return;
    el.textContent = text;
    el.className = 'plw-form__msg plw-form__msg--' + kind;
  }

  /* On a JSON template Shopify renders section ids as
     shopify-section-template--NNN__key, so a hand-written #shopify-section-key
     anchor never resolves. Point any in-page link at whatever the section
     actually rendered as. */
  function resolveAnchors() {
    document.querySelectorAll('.plw a[href^="#"]').forEach(function (a) {
      var hash = a.getAttribute('href').slice(1);
      if (!hash || document.getElementById(hash)) return;
      var key = hash.replace(/^shopify-section-/, '');
      var target = document.querySelector('[id$="__' + key + '"]');
      if (target) a.setAttribute('href', '#' + target.id);
    });
  }

  /* Fallback email capture, used only when no Klaviyo form ID is set on the
     block. Posts straight to Klaviyo's client subscription API. */
  function bindFallbackForms() {
    document.querySelectorAll('form[data-plw-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var company = form.getAttribute('data-company');
        var list = form.getAttribute('data-list');
        var input = form.querySelector('input[type="email"]');
        var btn = form.querySelector('button');
        var msg = form.parentNode.querySelector('[data-plw-msg]');
        var email = (input && input.value || '').trim();

        if (!email) return;
        if (!company || !list) {
          show(msg, 'err', 'This form is not connected to a Klaviyo list yet.');
          return;
        }

        btn.disabled = true;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'content-type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        })
          .then(function (r) {
            if (r.ok) {
              form.reset();
              show(msg, 'ok', form.getAttribute('data-ok') || 'You are on the list.');
            } else {
              show(msg, 'err', form.getAttribute('data-err') || 'Something went wrong. Please try again.');
            }
          })
          .catch(function () {
            show(msg, 'err', form.getAttribute('data-err') || 'Something went wrong. Please try again.');
          })
          .then(function () { btn.disabled = false; });
      });
    });
  }

  function init() {
    resolveAnchors();
    bindFallbackForms();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
